define('viewmodels/Error',['plugins/router', 'services/appsecurity', 'services/navigation', 'services/logger', 'services/AppRoutes', 'viewmodels/GeneralSettings', 'viewmodels/header'],
    function (router, appsecurity, navigation, logger, AppRoutes, ObjGeneralSettings, header) {
        var title = 'Landing';
        var vm = {
            activate: function () {
            },
            appsecurity: appsecurity,
            AppRoutes: AppRoutes,
            attached: attached,
            detached: detached,
            header: header
        };
        return vm;

        function attached() {
            try {
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in Landing.js';
                logger.logMessage(msg);
            }
        }

    });



